import { useMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  symbol: string;
};

export default function OpenInterest({ symbol }: Props) {
  const { openInterest, priceDecimals, sizeDecimals } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      openInterest: state.marketData.openInterest ?? 0n,
      priceDecimals: state.marketSpec.priceDecimals,
      sizeDecimals: state.marketSpec.sizeDecimals,
    })),
  );
  return formatBigInt(openInterest, priceDecimals + sizeDecimals, {
    digits: 2,
    style: 'currency',
    compact: true,
  });
}

export const openInterestAccessorFn = (symbol: string) => {
  const {
    marketData: { openInterest = 0n },
    marketSpec: { priceDecimals, sizeDecimals },
  } = useMarketStore(symbol).getState();
  return bigIntToNum(openInterest, priceDecimals + sizeDecimals);
};
